import React, { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import { ApartmentAccessMethod, PetsInformation } from '@models/api';
import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { TitleDescriptionIncidentForm } from '../../components/TitleDescriptionIncidentForm';
import { ApartmentDefectFormKey } from '../../MessageForms.types';
import { ApartmentDefectCommonForm } from '../components/ApartmentDefectCommonForm';

import { ApartmentDefectAppliance } from './ApartmentDefectAppliance';
import { ApartmentDefectTemperature } from './ApartmentDefectTemperature';

export const apartmentDefectForms: Record<
  ApartmentDefectFormKey,
  FC<ParsedEntry<IWidget>>
> = {
  // Apartment defects
  [ApartmentDefectFormKey.DEFECT_APARTMENT_APPLIANCE]: ApartmentDefectAppliance,

  [ApartmentDefectFormKey.DEFECT_APARTMENT_TEMPERATURE]:
    ApartmentDefectTemperature,

  [ApartmentDefectFormKey.DEFECT_APARTMENT_ELECTRICAL]: (props) => (
    <ApartmentDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.ELECTRICITY_DEFECT}
    />
  ),

  [ApartmentDefectFormKey.DEFECT_APARTMENT_PESTS]: (props) => (
    <ApartmentDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.PEST_CONTROL}
    />
  ),

  [ApartmentDefectFormKey.DEFECT_APARTMENT_VENTILATION]: (props) => (
    <ApartmentDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.INDOOR_AIR_QUALITY}
    />
  ),

  [ApartmentDefectFormKey.DEFECT_APARTMENT_OTHER]: (props) => (
    <ApartmentDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.OTHER_APARTMENT_DEFECT}
    />
  ),

  [ApartmentDefectFormKey.DEFECT_APARTMENT_MINOR_REPAIR_REQUEST]: (props) => (
    <ApartmentDefectCommonForm
      {...props}
      subClassification={IncidentSubClassification.SMALL_DEFECT}
    />
  ),

  [ApartmentDefectFormKey.PAID_HOUSE_EXPERT_WORK_1_HOUR]: (props) => (
    <TitleDescriptionIncidentForm
      {...props}
      classifications={{
        classification: IncidentClassification.DEFECT_REPORT,
        subClassification:
          IncidentSubClassification.PAID_HOUSE_EXPERT_WORK_1_HOUR,
      }}
      translations={props.customTranslations}
      postIncident={(values) =>
        api.incidents.postApartmentDefectIncident({
          ...values,
          access: ApartmentAccessMethod.AGREE_ON_TIME,
          pets: PetsInformation.UNKNOWN,
        })
      }
      incidentKind="PaidHouseExpertWork1Hour"
      className="border-none"
      withFileUpload
    />
  ),

  [ApartmentDefectFormKey.DEFECT_APARTMENT_NAME_UPDATE]: (props) => (
    <TitleDescriptionIncidentForm
      {...props}
      postIncident={api.incidents.postNameUpdateRequest}
      translations={props.customTranslations}
      classifications={{
        classification: IncidentClassification.DEFECT_REPORT,
        subClassification: IncidentSubClassification.NAME_UPDATE,
      }}
      incidentKind="ApartmentDefectNameUpdate"
      className="border-none p-0"
    />
  ),
};
